import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'tenders/searcheswithid',
    template: '<div></div>'
})
export class TendersSearchWithIdComponent implements OnInit {
    private readonly fromUrlKey = 'searchTenderId';
    routeParamsSub: Subscription;

    constructor(private readonly router: Router, private readonly route: ActivatedRoute) {
        
    }

    ngOnInit() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            localStorage.setItem(this.fromUrlKey, params['id']);

            this.router.navigateByUrl('/tenders/search');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/tenders/search.with.id.component.ts